<template>
  <div class="bg-white">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Info Drop Point</p>
        <div class="mb-6 max-w-sm">
          <TextField type="text" label="ID" :disabled="true" v-model="id" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Nama Hub" v-model="payloads.name" placeholder="Nama drop off point" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Coordiate latitude" v-model="payloads.coord_lat" placeholder="Masukan koordinat lokasi latitude" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Coordiate longitude" v-model="payloads.coord_lng" placeholder="Masukan koordinat lokasi longitude" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Jam Operasi" v-model="payloads.operation_hour_display" placeholder="Masukan jam operasi" />
        </div>
        <div class="mb-6">
          <Textarea label="Alamat" v-model="payloads.address" placeholder="Alamat" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Wilayah</label>
          <CustomSelect :options="cities" v-model="selectedCity" placeholder="Pilih wilayah" optionLabel="name" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Provinsi</label>
          <CustomSelect :options="provinces" v-model="selectedProvince" placeholder="Pilih provinsi" optionLabel="name" />
        </div>
        <div class="mb-6" v-if="visibleDistrict">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kota / Kabupaten</label>
          <CustomSelect :options="districts" v-model="selectedDistrict" :default="selectedDistrict" placeholder="Pilih kota" optionLabel="name" />
        </div>
        <div class="mb-6" v-if="visibleSubDistrict">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kecamatan</label>
          <CustomSelect :options="subDistricts" v-model="selectedSubDistrict" :default="selectedSubDistrict" placeholder="Pilih kecamatan" optionLabel="name" />
        </div>
        <div class="mb-6" v-if="visibleUrbanVillage">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kelurahan</label>
          <CustomSelect :options="urbanVillages" v-model="selectedUrbanVillage" :default="selectedUrbanVillage" placeholder="Pilih kelurahan" optionLabel="name" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Kode Hub" :disabled="true" v-model="payloads.hub_code" placeholder="Akan terisi otomatis" />
        </div>
      </div>
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <div class="p-6 ">
          <p class="font-bold text-lg mb-6">PIC</p>
          <div class="mb-6">
            <TextField type="text" label="Nama PIC 1" v-model="payloads.primary_pic_name" placeholder="Masukan PIC pertama" />
          </div>
          <div class="mb-6">
            <TextField type="text" label="No Handphone" v-model="payloads.primary_pic_phoneno" placeholder="Masukan no handphone" />
          </div>
          <div class="mb-6">
            <TextField type="text" label="Nama PIC 2" v-model="payloads.secondary_pic_name" placeholder="Masukan PIC kedua" />
          </div>
          <div class="mb-6">
            <TextField type="text" label="No Handphone" v-model="payloads.secondary_pic_phoneno" placeholder="Masukan no handphone" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      payloads: {
        name: null,
        coord_lat: null,
        coord_lng: null,
        operation_hour_display: null,
        address: null,
        area_code: '',
        province_code: null,
        district_code: null,
        subdistrict_code: null,
        urbanvillage_code: null,
        hub_code: '',
        primary_pic_name: null,
        primary_pic_phoneno: null,
        secondary_pic_name: null,
        secondary_pic_phoneno: null,
        is_published: true
      },
      selectedProvince: null,
      selectedDistrict: null,
      selectedSubDistrict: null,
      selectedUrbanVillage: null,
      selectedCity: null,
      visibleDistrict: false,
      visibleSubDistrict: false,
      visibleUrbanVillage: false,
      id: null,
      options: ['A', 'B', 'C']
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('master', ['provinces', 'districts', 'subDistricts', 'urbanVillages', 'cities']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    }
  },
  created() {
    this.getProvinceList()
    this.getCityList()
  },
  watch: {
    selectedProvince(val) {
      if (val) {
        this.visibleDistrict = true
        this.selectedDistrict = null
        this.payloads.province_code = parseInt(val.code)
        this.getDistrictList(val.code)
      }
    },
    selectedDistrict(val) {
      if (val) {
        this.visibleSubDistrict = true
        this.selectedSubDistrict = null
        this.payloads.district_code = parseInt(val.code)
        this.getSubDistrictList(this.selectedProvince.code, val.code)
      }
    },
    selectedSubDistrict(val) {
      if (val) {
        this.visibleUrbanVillage = true
        this.selectedUrbanVillage = null
        this.payloads.subdistrict_code = parseInt(val.code)
        this.getUrbanVillageList(this.selectedProvince.code, this.selectedDistrict.code, val.code)
      }
    },
    selectedUrbanVillage(val) {
      if (val) {
        this.payloads.urbanvillage_code = parseInt(val.code)
      }
    },
    selectedCity(val) {
      if (val) {
        this.payloads.area_code = val.code
      }
    }
  },
  methods: {
    ...mapActions('master', ['getProvinces', 'getDistricts', 'getSubDistricts', 'getUrbanVillages', 'getCities']),
    ...mapActions('hub', ['createHub']),
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading']),
    getProvinceList() {
      this.getProvinces()
    },
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    getDistrictList(provinceId) {
      this.selectedSubDistrict = null
      this.visibleSubDistrict = false
      this.selectedUrbanVillage = null
      this.visibleUrbanVillage = false
      this.getDistricts({
        provinceId: provinceId
      })
    },
    getSubDistrictList(provinceId, districtId) {
      this.selectedUrbanVillage = null
      this.visibleUrbanVillage = false
      this.getSubDistricts({
        provinceId: provinceId,
        districtId: districtId
      })
    },
    getUrbanVillageList(provinceId, districtId, subDistrictId) {
      this.getUrbanVillages({
        provinceId: provinceId,
        districtId: districtId,
        subDistrictId: subDistrictId
      })
    },
    submit() {
      this.showLoading()
      this.createHub({
        partnerId: this.partnerId,
        payloads: this.payloads
      })
        .then(() => {
          this.hideLoading()
          const promise = new Promise((resolve, reject) => {
            this.setToast({
              options: { type: 'success', duration: 3000, primaryText: 'Penambahan Hub Berhasil', secondaryText: 'Data telah kami simpan' }
            })
            resolve()
          })
          promise.then(() => {
            this.$router.push('/hub')
          })
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  }
}
</script>
